<template>
    <div v-show="!loading" class="welcome-page">
        <section class="welcome-block">
            <b-img width="200" height="200" fluid :src="require('../assets/img/branding/' + logoName)"></b-img>

            <br>

            <b-card>
                <b-form @submit.prevent="login">
                    <b-form-group>
                        <label v-tr>Email|Courriel</label>
                        <e-input ref="email" id="welcome-email" class="form-control" name="email" required v-model="email" type="email" maxlength="250"/>
                    </b-form-group>

                    <b-form-group>
                        <label v-tr>Password|Mot de passe</label>
                        <e-input ref="password" id="welcome-password" class="form-control" name="password" required v-model="password" type="password" maxlength="250"/>
                    </b-form-group>

                    <div class="mt-4 mb-3">
                        <b-btn block type="submit" variant="primary"><span v-tr>Sign In |Se connecter </span></b-btn>
<!--                        <GoogleLogin class="mt-4" :params="params" :renderParams="renderParams" :onSuccess="onGoogleLoginSuccess" :onFailure="onGoogleLoginFailure"></GoogleLogin>-->

                        <b-btn block @click="goToRegister" class="mt-4" variant="outline-primary">
                            <span v-tr>Not a member already?|Pas encore membre?</span>
                            <i class="fas fa-arrow-right ml-2"></i>
                        </b-btn>

                        <e-btn-social-login block class="mt-4" api-base-url="/wifi/client/user/social-login" type="facebook"></e-btn-social-login>

                        <hr>

                        <a v-b-modal.modal-association href="#" class="basic-link d-block mt-4" v-tr>Forgot your password?|Mot de passe oublié?</a>

                        <p class="mt-4">
                            <a @click="changeLanguage()" href="#" class="basic-link text-info text-underline f-500" v-tr>Français|English</a>
                        </p>
                        <div>
                            <a class="mt-1 mb-2 f-9 text-gray" v-tr>Powered by Eye-In Media|Populsé par Eye-In Media</a>
                        </div>
                    </div>
                </b-form>

                <div class="clearfix"></div>
                <div v-if="isFromWifi" class="text-center mt-4">
                    <b-btn @click="window.history.back()" variant="outline-primary">
                        <i class="fas fa-chevron-left mr-1"></i>
                        <span v-tr>Back to the login page|Retour à la page de connexion</span>
                    </b-btn>
                </div>

            </b-card>
        </section>

        <b-modal id="modal-association" :title="'Recover password|Retrouver votre mot de passe'|tr" @ok="forgotPassword">
            <p v-tr>Please enter your email address to change your password.|Merci d'entrer votre courriel pour retrouver votre mot de passe.</p>
            <b-form-group :label="'Email|Addresse courriel'|tr">
                <b-input-group>
                    <b-input type="email" maxlength="250" v-model="recovery.email" :state="emailValid"></b-input>
                </b-input-group>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import EBtnSocialLogin from "../../vue-components/components/e-btn-social-login.vue";
import Network from "../../vue-components/helpers/Network";
import {changeLanguage, setLanguage, isFrench} from "../../vue-components/helpers/i18n";

export default {
    name: `login`,
    components: {EBtnSocialLogin},
    data() {
        return {
            isFrench: isFrench,
            email: ``,
            password: ``,
            loading: false,
            displayProductName: false,
            mac_address: null,
            recovery: {
                email: ``
            },
            params: {
                client_id: `263127917827-c81c1qgp7o97qsa9t1p8aj7ou320vkp8`
            },
            renderParams: {
                height: 33,
                longtitle: true,
                theme: `dark`
            },
            rememberPassword: false
        }
    },
    mounted() {
        if (this.$route.params.guid)
            this.activateAccount();
        if (this.$route.params.language)
            setLanguage(this.$route.params.language);
        if (this.$route.query.error) {
            switch (this.$route.query.error) {
                case `no_account`:
                    this.$swal(this.tr(`No Account Found|Aucun compte trouvé`), this.tr(`Please make sure you used the right account and try again|Merci de vérifier que vous avez utilisé le bon compte et réessayez`), `info`)
                    break;
                default:
                    this.$swal(this.tr(`Can't login|Connexion non disponible`), this.tr(`Please try again later|Merci de réessayer plus tard`), `info`)
                    break;
            }
        }

        this.$store.dispatch(`getCurrentUser`)
            .then(user => {
                if (user) {
                    this.$router.push(`/`);
                }
            });
    },
    async activated() {
        this.loading = false;
        this.$emit(`login-start`);
        this.email = ``;
        this.password = ``;
        this.recovery.email = ``;
    },
    computed: {
        emailValid() {
            return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(this.recovery.email);
        }
    },
    methods: {
        goToRegister() {
            this.$router.push(`/register`);
        },
        changeLanguage() {
            changeLanguage();
            this.$forceUpdate();
        },
        onLogUser() {
            this.$emit(`login-finished`);

            this.redirectToLoginPage();
        },
        login() {
            this.$store.dispatch(`login`, {
                url: `/wifi/client/user/login`,
                params: {
                    email: this.email,
                    password: this.password,
                    mac_address: this.$route.query.mac_address
                }
            }).then(this.onLogUser).catch(res => {
                if (res.data === `login_invalid`) {
                    this.$swal({
                        icon: `error`,
                        title: this.tr([`Could not login`, `Connexion non valide`]),
                        text: this.tr([`Wrong email or password.`, `Mauvais nom d'utilisateur ou mot de passe`])
                    });
                } else if (res.data === `activation_needed`) {
                    this.$swal({
                        icon: `warning`,
                        title: this.tr([`Email verification needed`, `Vérification du courriel demandée`]),
                        text: this.tr([`Check your email, you received a verification link`, `Regardez vos courriels, vous avez reçu un lien de vérification`]),
                        buttons: {
                            resend: {
                                value: `resend`,
                                text: this.tr([`Resend verification link`, `Renvoyez le lien de vérification`])
                            },
                            default: `OK`
                        }
                    }).then(value => {
                        if (value === `resend`) {
                            Network.post(`/wifi/client/user/send-verification`, {
                                email: this.email
                            });
                        }
                    })
                } else {
                    this.$swal({
                        icon: `error`,
                        title: this.tr([`Error`, `Erreur`]),
                        text: this.tr([`Something wrong happened`, `Une erreur s'est produite`])
                    });
                }
            });
        },
        onGoogleLoginSuccess(googleUser) {
            this.$store.dispatch(`login`, {
                url: `/wifi/client/user/login-with-google`,
                params: {
                    google_token: googleUser.getAuthResponse().id_token
                }
            }).then(() => {
                this.$emit(`login-finished`);
                this.redirectToLoginPage();
                if (!this.user.active) {
                    Network.post(`/wifi/client/user/activate`, {
                        guid: this.user.activation_guid
                    });
                }
            }).catch(res => {
                this.$swal({
                    icon: `error`,
                    title: this.tr([`Could not login`, `Connexion non valide`]),
                    text: this.tr([`Google did not validate the login`, `Google n'a pas validé l'authentification`])
                });
            });
        },
        onGoogleLoginFailure() {
            this.$toast.error(this.tr([`Error`, `Erreur`], this.tr([`Login with google failed`, `Connexion avec Google échouée`])));
        },
        forgotPassword() {
            if (this.recovery.email === ``)
                return;
            Network.post(`/wifi/client/user/forgot-password`, {
                email: this.recovery.email
            }).then(resp => {
                this.$swal({
                    icon: `success`,
                    title: this.tr([`Email sent`, `Courriel envoyé`]),
                    text: this.tr([`An email has been sent with further information.`, `Un courriel vous a été envoyé avec plus d'informations`])
                });
            }).catch(resp => {
                this.$swal({
                    icon: `error`,
                    title: this.tr([`No account found`, `Aucun compte associé`]),
                    text: this.tr([`Thank you for verifying that your username and email are valid`, `Merci de vérifier que votre nom d'utilisateur et courriel sont valides`])
                });
            });
            this.recovery.email = ``;
        },
        redirectToLoginPage() {
            const redirect = localStorage.getItem(`redirect`);
            if (redirect) {
                localStorage.removeItem(`redirect`);
                this.reach(redirect);
            } else {
                this.reach(`/`);
            }
        },
        activateAccount() {
            this.$store.dispatch(`login`, {
                url: `/wifi/client/user/activate`,
                params: {
                    guid: this.$route.params.guid
                }
            }).then(() => {
                this.$swal({
                    icon: `success`,
                    title: this.tr([`Congratulations!`, `Félicitations !`]),
                    text: this.tr([`Your account has been successfuly activated!`, `Votre compte a été activé avec succès !`])
                });
                this.onLogUser();
            }).catch(res => {
                if (res.data === `user_already_active`) {
                    this.$swal({
                        icon: `warning`,
                        title: this.tr([`Oops!`, `Oops !`]),
                        text: this.tr([`This user is already logged in`, `Ce compte est déjà activé`])
                    });
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../assets/style/welcome-page";

form {
    max-width: 300px;

    input {
        text-align: center;
    }
}
</style>
